import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { testimonials } from '../mockData';

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-white via-blue-50/30 to-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header - Enhanced */}
        <div className="text-center mb-20">
          <div className="inline-block mb-4">
            <span className="px-6 py-2 rounded-full bg-gradient-to-r from-yellow-100 to-amber-100 text-amber-600 font-semibold text-sm tracking-wider uppercase">
              Reference
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6 bg-gradient-to-r from-gray-900 via-blue-900 to-gray-900 bg-clip-text text-transparent">
            Co říkají moji zákazníci
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Spokojenost zákazníků je moje priorita
          </p>
        </div>

        {/* Testimonials Grid - Enhanced */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-16">
          {testimonials.map((testimonial, index) => (
            <Card
              key={testimonial.id}
              className="group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 border-0 bg-white relative overflow-hidden flex flex-col"
              style={{
                animationDelay: `${index * 100}ms`
              }}
            >
              {/* Gradient Accent */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 to-cyan-500"></div>
              
              <CardContent className="pt-8 pb-6 flex flex-col flex-1">
                {/* Stars with Animation */}
                <div className="flex gap-1 mb-6">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star 
                      key={i} 
                      size={22} 
                      className="fill-yellow-400 text-yellow-400 transform group-hover:scale-110 transition-transform duration-300"
                      style={{ transitionDelay: `${i * 50}ms` }}
                    />
                  ))}
                </div>

                {/* Quote with Better Typography - flexible space */}
                <p className="text-gray-700 mb-8 italic leading-relaxed text-base flex-1">
                  &ldquo;{testimonial.text}&rdquo;
                </p>

                {/* Author with Enhanced Styling - always at bottom */}
                <div className="border-t border-gray-200 pt-4 mt-auto">
                  <p className="font-black text-gray-900 text-lg">{testimonial.name}</p>
                  <p className="text-sm text-blue-600 font-semibold">{testimonial.location}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to Action - Enhanced with 4.8 Rating */}
        <div className="text-center bg-gradient-to-r from-blue-600 to-cyan-600 rounded-3xl p-12 shadow-2xl">
          <p className="text-xl text-white mb-6 font-semibold">
            Staňte se součástí spokojených zákazníků
          </p>
          <p className="text-lg text-white/90 mb-6">
            Kontaktujte mě pro individuální nabídku
          </p>
          <div className="flex items-center justify-center gap-3 text-white">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={24} className={`${i < 4 ? 'fill-yellow-300 text-yellow-300' : 'fill-yellow-300/50 text-yellow-300'}`} />
              ))}
            </div>
            <span className="text-3xl font-black">4.8</span>
            <span className="text-lg opacity-90">z hodnocení zákazníků</span>
          </div>
        </div>
      </div>
    </section>
  );
};
